<template>
  <v-card class="card-not-received-campaigns">
    <v-card-title class="pa-2 pl-1">
      <v-container fluid fill-height>
        <span class="table-card-title">Clientes que não receberam campanhas</span>
      </v-container>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
        class="elevation-1"
        hide-default-footer
        no-data-text="Não existem dados a serem exibidos. Selecione outro período ou entre em contato com o suporte pelo chat."
        :headers="headers"
        :items="tableItems"
        :loading="loading"
      >
        <template v-slot:item.clients="{ item }">
          {{ item.clients }}<mf-quick-actions v-if="item.quickActionsProps" v-bind="item.quickActionsProps" />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { criteriaGroup, didNotReceiveMessageOnChannelCriteria } from '@/components/quick-actions/segmentationGroups.js'
import { assertArray, localeString } from '@/config/helpers.js'
import { QUERY_CLIENTS_NOT_RECEIVED_CAMPAIGNS_BY_CHANNEL } from '@/modules/campanhas/resultados-gerais/graphql'
import { mapState } from 'vuex'
export default {
  name: 'NotReceivedCampaignsTable',
  props: {
    campaignIds: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Canal',
        value: 'channelName',
        width: '33%',
        sortable: true,
      },
      {
        text: 'Clientes',
        value: 'clients',
        width: '33%',
        sortable: true,
      },
      {
        text: 'Representatividade',
        value: 'percentage',
        width: '33%',
        sortable: true,
      },
    ],
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    skipQuery() {
      return !this.defaultQueryVariables || !this.defaultQueryVariables.initialDate || !this.defaultQueryVariables.finalDate || !this.campaignIds.length
    },
    loading() {
      return this.$apollo.queries.clientsNotReceivedCampaigns.loading
    },
    tableItems() {
      const channels = this.stateFilters.channels
      if (!this.$apollo.queries.clientsNotReceivedCampaigns.loading && channels && this.campaignIds.length) {
        return this.defaultTableItems.map((item) => {
          const index = this.clientsNotReceivedCampaigns.findIndex((i) => i.channel === item.channel)
          let channelItem = item
          if (index > -1) {
            channelItem.clients = localeString(this.clientsNotReceivedCampaigns[index].clients_not_received_count)
            channelItem.percentage = this.clientsNotReceivedCampaigns[index].percent + '%'
            channelItem.quickActionsProps = this.getQuickActionProps(channelItem.channel)
          }
          return channelItem
        })
      }
      return []
    },
    defaultTableItems() {
      return [
        {
          channel: 'WHATSAPP',
          channelName: 'Whatsapp',
          clients: '-',
          percentage: '-',
        },
        {
          channel: 'SMS',
          channelName: 'SMS',
          clients: '-',
          percentage: '-',
        },
        {
          channel: 'PUSH',
          channelName: 'Push aplicativo',
          clients: '-',
          percentage: '-',
        },
        {
          channel: 'EMAIL',
          channelName: 'E-mail',
          clients: '-',
          percentage: '-',
        },
      ]
    },
    defaultQueryVariables() {
      const { data } = this.stateFilters
      const [initialDate = '', finalDate = ''] = assertArray(data)
      const variables = {
        initialDate,
        finalDate,
        channels: this.stateFilters.channels,
        campaignIds: this.campaignIds,
      }

      return variables
    },
  },
  apollo: {
    clientsNotReceivedCampaigns: {
      query: QUERY_CLIENTS_NOT_RECEIVED_CAMPAIGNS_BY_CHANNEL,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      update({ clientsNotReceivedCampaignsByChannel }) {
        return clientsNotReceivedCampaignsByChannel
      },
      variables() {
        return this.defaultQueryVariables
      },
      context() {
        return {
          uri: this.$microservicesUrls['campaigns'],
        }
      },
      skip() {
        return this.skipQuery
      },
    },
  },
  methods: {
    formatChannels(channels) {
      const formattedChannels = {
        SMS: 'SMS',
        EMAIL: 'E-mail',
        WHATSAPP: 'WhatsApp',
        PUSH: 'Push Aplicativo',
      }
      return channels.map((channel) => formattedChannels[channel]).join(', ')
    },
    getQuickActionProps(channel) {
      return {
        quickActionGroupId: `clients-did-not-receive-message-on-channel-${channel}`,
        shortDescription: (formatters, channels) => {
          return `Clientes que não receberam campanhas ${this.formatChannels([channel])}`
        },
        longDescription: ({ startDate, endDate }, channels) => {
          return `Clientes que não receberam campanhas ${this.formatChannels([channel])} entre ${startDate} e ${endDate}`
        },
        segmentationGroup: ({ dateCriteriaFilter }) =>
          criteriaGroup([didNotReceiveMessageOnChannelCriteria(this.defaultQueryVariables.campaignIds, [channel], ...dateCriteriaFilter)]),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card-not-received-campaigns {
  & h2 {
    color: $cinza-d20;
    font-size: 22px;
    font-weight: normal;
  }
}
::v-deep .v-data-table__empty-wrapper {
  color: $cinza-l50 !important;
}
</style>
